import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import * as actions from '../../_common/actions/generalData';

type TextSuggestionsContext = {
  textSuggestions: {
    description: TextOption[],
    remarks: TextOption[],
    footer: TextOption[],
  },
}

export type TextOption = {
  label: string;
  value: string;
  documentTypeID: number;
}

interface TextSuggestionsProviderProps {
  children: ReactNode;
}

const defaultContext = {
  textSuggestions: {
    description: [],
    remarks: [],
    footer: [],
  }
};

const TextSuggestionsContext = createContext<TextSuggestionsContext>(defaultContext);

export const useTextSuggestionsContext = () => useContext(TextSuggestionsContext);

export const TextSuggestionsProvider = ({children}: TextSuggestionsProviderProps) => {
  const [textSuggestions, setTextSuggestions] = useState(defaultContext.textSuggestions);

  const getData = async () => {
    try {
      const textSuggestions = await actions.getTextSuggestions();
      setTextSuggestions(textSuggestions);
    } catch (e) {
      console.error(e);
      setTextSuggestions(defaultContext.textSuggestions);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TextSuggestionsContext.Provider value={{textSuggestions}}>
      {children}
    </TextSuggestionsContext.Provider>
  );
};